import { Link } from "react-router-dom";
import { ArrowUpRight, Palmtree } from "lucide-react";
import { Reveal } from "./motion";

export const TravelBanner = () => (
  <section data-testid="travel-banner" className="border-t border-navy/10 bg-sage/60">
    <div className="mx-auto flex max-w-[1600px] flex-wrap items-center justify-between gap-8 px-6 py-16 md:px-12 md:py-20">
      <Reveal>
        <p className="-rotate-2 font-caveat text-3xl font-semibold text-navy/80">going somewhere?</p>
        <h2 className="mt-3 font-playfair text-4xl leading-[0.95] tracking-tight text-navy md:text-6xl">
          Dream Freely Travel
        </h2>
        <p className="mt-4 max-w-lg text-sm leading-relaxed text-navy/70 md:text-base">
          Personalized travel booking with our independent InteleTravel agency — cruises, resorts, air and tours,
          planned around you.
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="flex flex-wrap items-center gap-4">
          <Link
            to="/travel"
            data-testid="travel-banner-form-btn"
            className="group inline-flex items-center gap-3 rounded-full bg-navy px-8 py-4 text-xs font-medium uppercase tracking-[0.25em] text-cream transition-transform duration-300 hover:scale-95"
          >
            <Palmtree className="h-4 w-4" />
            Book travel
          </Link>
          <a
            href="https://edrinaafre.inteletravel.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="travel-banner-site-btn"
            className="group inline-flex items-center gap-3 rounded-full border border-navy px-8 py-4 text-xs font-medium uppercase tracking-[0.25em] text-navy transition-transform duration-300 hover:scale-95"
          >
            Visit the booking site
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
